import {useBoolVariation} from '@launchdarkly/react-sdk';
import type {FlagDef} from './types';

export function useFeatureFlag(flag: FlagDef<boolean>): boolean {
  return useBoolVariation(flag.key, flag.defaultValue);
}
